import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import '../../carousel-styles.css';

import CarouselWithScrollbar from '../../atoms/CarouselWithScrollbar';
import { MText } from '../../atoms/MText';
import { MBox } from '../../atoms/MBox';
import MdText from '../../MdText';

const StyledCarouselWrapper = styled(MBox)`
  .mr-products-container-carousel--with-dots {
    padding: 0px 0px 18px 0px;
  }

  .mr-products-container-carousel__dot-list {
    display: flex;
    padding: 0px 0px 8px 0px;

    .react-multi-carousel-dot {
      line-height: 1px;
    }

    .react-multi-carousel-dot.react-multi-carousel-dot--active button {
      background-color: ${props => props.carouselActionColor} !important;
    }

    .react-multi-carousel-dot button {
      padding: 0px !important;
      background-color: transparent !important;
      min-height: 10px;
      height: 10px;
      min-width: 10px !important;
      width: 10px !important;
      border-color: ${props => props.carouselActionColor} !important;
    }
  }
  .react-multi-carousel-list {
    overflow: hidden;
  }

  .react-multi-carousel-track {
    padding: 0 !important;
  }

  .mr-products-container-carousel__arrows {
    opacity: 0;
    transition: ease-in all 0.2s;
  }

  .react-multiple-carousel__arrow {
    padding: 0px;
    background-color: #00000050;
    min-height: fit-content;
    min-width: fit-content;
    height: 34px;
    width: 34px;
    z-index: 1;
    bottom: 50%;
    transform: translateY(-50%);

    :hover {
      background-color: #00000050;
    }
  }
  .react-multiple-carousel__arrow--left {
    left: 6px;
    ::before {
      width: 12px;
      height: 12px;
      border-left: 3px solid white;
      border-bottom: 3px solid white;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-35%, -50%) rotate(45deg);
    }
  }
  .react-multiple-carousel__arrow--right {
    right: 6px;
    ::before {
      width: 12px;
      height: 12px;
      border-right: 3px solid white;
      border-top: 3px solid white;
      position: absolute;
      top: 50%;
      right: 50%;
      transform: translate(35%, -50%) rotate(45deg);
    }
  }
`;

export default function EmbeddedCrossSellOfferCon(props) {
  const {
    isMobile,
    renderInCarousel,
    carouselItemsToShow,
    productContainerClassName = '',
    offerHeaderText,
    offerHeaderFontSize,
    offerHeaderMobileFontSize,
    offerHeaderTextColor,
    offerHeaderFontStyle,
    offerHeaderFontWeight,
    offerHeaderTextDecoration,
    offerHeaderFontFamily,
    offerHeaderTextAlignment,
    offerHeaderPadding,
    offerHeaderMargin,
    offerSubtitleText,
    offerSubtitleFontSize,
    offerSubtitleMobileFontSize,
    offerSubtitleTextColor,
    offerSubtitleFontStyle,
    offerSubtitleFontWeight,
    offerSubtitleTextDecoration,
    offerSubtitleFontFamily,
    offerSubtitleTextAlignment,
    offerSubtitlePadding,
    offerSubtitleMargin,
    productsContainerPadding,
    productsContainerMargin,
    carouselActionColor = '#000000',
    children,
    offerLevelDiscountQuantity,
    offerLevelQuantityAdded,
    productButtonColor,
    productButtonStyle,
    productButtonTextColor,
    countOfItemsInOffer,
    isCarouselArrowsAlwaysVisible,
    carousalStyleProps,
  } = props;

  const carouselRef = useRef();

  const responsive = {
    desktop: {
      breakpoint: { max: 5000, min: 576 },
      items: carouselItemsToShow,
    },
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: carouselItemsToShow,
    },
  };

  useEffect(
    () => {
      if (carouselRef.current) {
        if (carouselRef.current.state.currentSlide >= children.length - 1) {
          carouselRef.current.goToSlide(children.length - 1);
        }
      }
    },
    [children.length],
  );

  useEffect(
    () => {
      if (carouselRef.current) {
        carouselRef.current.setItemsToShow();
      }
    },
    [carouselItemsToShow],
  );
  let offerHeaderCopy = offerHeaderText.slice();

  offerHeaderCopy = offerHeaderCopy
    .replace('{{added_count}}', `${offerLevelQuantityAdded.toString()}`)
    .replace('{{total_count}}', `${offerLevelDiscountQuantity.toString()}`);

  let width = null;

  if (renderInCarousel) {
    width = isMobile ? '75%' : '90%';
  }

  return (
    <>
      <MdText
        fontSize={`${offerHeaderFontSize}px`}
        alignment={offerHeaderTextAlignment}
        color={offerHeaderTextColor}
        fontWeight=""
        fontFamily={offerHeaderFontFamily}
        padding={offerHeaderPadding}
        margin={offerHeaderMargin}
        className="mr-embedded-widget__offer-header"
      >
        {offerHeaderCopy}
      </MdText>
      {offerSubtitleText && (
        <MdText
          fontSize={`${
            isMobile ? offerSubtitleMobileFontSize : offerSubtitleFontSize
          }px`}
          alignment={offerSubtitleTextAlignment}
          color={offerSubtitleTextColor}
          fontWeight=""
          fontFamily={offerSubtitleFontFamily}
          padding={offerSubtitlePadding}
          margin={offerSubtitleMargin}
          className="mr-embedded-widget__offer-subtitle"
        >
          {offerSubtitleText}
        </MdText>
      )}
      {renderInCarousel ? (
        <StyledCarouselWrapper
          padding={productsContainerPadding}
          margin={productsContainerMargin}
          carouselActionColor={carouselActionColor}
          className={`mr-embedded-widget__products-container ${productContainerClassName}`}
        >
          <CarouselWithScrollbar
            responsive={responsive}
            isMobile={isMobile}
            countOfItemsInOffer={countOfItemsInOffer}
            thumbColor={
              productButtonStyle === 'text'
                ? productButtonTextColor
                : productButtonColor
            }
            isCarouselArrowsAlwaysVisible={isCarouselArrowsAlwaysVisible}
            arrowsWithTitle
            carousalStyleProps={carousalStyleProps}
            carouselRef={carouselRef}
          >
            {children}
          </CarouselWithScrollbar>
        </StyledCarouselWrapper>
      ) : (
        <MBox
          padding={productsContainerPadding}
          margin={productsContainerMargin}
          className={`mr-embedded-widget__products-container ${productContainerClassName}`}
        >
          {children}
        </MBox>
      )}
    </>
  );
}

EmbeddedCrossSellOfferCon.propTypes = {
  isMobile: PropTypes.bool,
  renderInCarousel: PropTypes.bool,
  carouselItemsToShow: PropTypes.number,
  children: PropTypes.node,
  productContainerClassName: PropTypes.string,
  offerHeaderText: PropTypes.string,
  offerHeaderFontSize: PropTypes.string,
  offerHeaderMobileFontSize: PropTypes.string,
  offerHeaderTextColor: PropTypes.string,
  offerHeaderFontStyle: PropTypes.string,
  offerHeaderFontWeight: PropTypes.string,
  offerHeaderTextDecoration: PropTypes.string,
  offerHeaderFontFamily: PropTypes.string,
  offerHeaderTextAlignment: PropTypes.string,
  offerHeaderPadding: PropTypes.string,
  offerHeaderMargin: PropTypes.string,
  offerSubtitleText: PropTypes.string,
  offerSubtitleFontSize: PropTypes.string,
  offerSubtitleMobileFontSize: PropTypes.string,
  offerSubtitleTextColor: PropTypes.string,
  offerSubtitleFontStyle: PropTypes.string,
  offerSubtitleFontWeight: PropTypes.string,
  offerSubtitleTextDecoration: PropTypes.string,
  offerSubtitleFontFamily: PropTypes.string,
  offerSubtitleTextAlignment: PropTypes.string,
  offerSubtitlePadding: PropTypes.string,
  offerSubtitleMargin: PropTypes.string,
  productsContainerPadding: PropTypes.string,
  productsContainerMargin: PropTypes.string,
  carouselActionColor: PropTypes.string,
  offerLevelDiscountQuantity: PropTypes.number,
  offerLevelQuantityAdded: PropTypes.number,
  productButtonColor: PropTypes.string,
  productButtonStyle: PropTypes.string,
  productButtonTextColor: PropTypes.string,
  countOfItemsInOffer: PropTypes.number,
  isCarouselArrowsAlwaysVisible: PropTypes.bool,
};

const CarouselCustomDot = ({ onClick, ...rest }) => {
  const { index, active } = rest;
  return (
    <li
      data-index={index}
      className={`react-multi-carousel-dot ${
        active ? 'react-multi-carousel-dot--active' : ''
      }`}
    >
      <button
        type="button"
        aria-label={`Go to slide ${index + 1}`}
        onClick={() => onClick()}
      />
    </li>
  );
};

CarouselCustomDot.propTypes = {
  onClick: PropTypes.func,
};
